const permissions = (state = [], action)=>{
    switch(action.type){
        case 'update' :
            {return action.val;}
        default :
            {return state}
    }
}
export default permissions;